/** @file clip.rename: renames a clip (its id stays). */
import { ERROR_CODES } from '@zilo/pose3d-format/errors/codes';
import { throwError } from '@zilo/pose3d-std/errors/throwError';
import type { CommandDef } from '../apply/commandDef';
import { findClip } from '../puppetDoc/findClip';
import { readInput } from '../validate/readInput';
import { refuseAttachmentPrefix } from '../validate/refuseAttachmentPrefix';

/** `clip.rename { clip, name }` → `{ name }`; a name another clip has is `VALIDATION`; inverse: rename back. */
export const clipRenameCommand: CommandDef<'clip.rename'> = {
  name: 'clip.rename',
  /** Checks the raw input (VALIDATION under the input path). */
  validate: (input, path) => {
    const r = readInput(input, path, ['clip', 'name']);
    return { clip: r.str('clip'), name: r.str('name') };
  },
  /** Applies the command to the draft and returns its result and inverse. */
  apply: (draft, input) => {
    const { name, clip } = findClip(draft, input.clip);
    refuseAttachmentPrefix(input.name, '/input/name');
    if (input.name !== name && Object.hasOwn(draft.clips, input.name)) {
      throwError(ERROR_CODES.VALIDATION, { clip: input.name }, { path: '/input/name', hint: 'another clip has this name' });
    }
    // eslint-disable-next-line @typescript-eslint/no-dynamic-delete -- clips are keyed by name
    delete draft.clips[name];
    clip.name = input.name;
    draft.clips[input.name] = clip;
    return { result: { name: input.name }, warnings: [], inverse: [{ name: 'clip.rename', input: { clip: input.name, name } }] };
  },
};
